<script>
export default {
	name: 'RCheckbox',
	emits: ['statusChange'],
	props: {
		checkStatus: {
			type: Boolean,
			default: false
		},
		innerCircleColor:{
			type: String,
			default: '#ff5e2a'
		},
		size: {
			type: Number,
			default: 18
		}
	},
	methods:{
		checkBoxClick(){
			this.isStatus = !this.isStatus
		}
	},
	computed: {
		isStatus:{
			get: function() {
				return this.checkStatus
			},
			set: function(val) {
				this.$emit('statusChange',val)
			}
		}
	}
}
</script>

<template>
	<div class="RCheckbox">
		<div class="circle" @click.stop="checkBoxClick" :style="`width: ${size}px; height: ${size}px;`">
			<div
				v-show="isStatus"
				:style="`width: ${size - 4}px; height: ${size - 4}px; background-color: ${innerCircleColor}`"
				class="innerCircle"
			></div>
		</div>
	</div>
</template>

<style scoped lang="scss">
.RCheckbox {
	.circle{
		display: flex;
		justify-content: center;
		align-items: center;
		border: 2px solid #fff;
		border-radius: 50%;
		background: #e0e0e0;
		.innerCircle{
			border-radius: 50%;
		}
	}
}
</style>
